/** @format */

export const FEEDBACKS = "FEEDBACKS";
export const PILOTUSER = "PILOTUSER";
export const INVITEFRIEND = "INVITEFRIEND";
export const HELPINFO = "HELPINFO";